export default "__VITE_ASSET__BWzarsNj__"